/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 项目演出大搜
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  condition: good.CategoryCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.RecommendProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/search-products-data`,
    data: condition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
